import React from 'react';
import { useState, useEffect } from 'react';
import './timer.css'
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Countdown from "react-countdown";
import GinGameWinPage from '../ModalPopup/GinGameWinPage';
import { useSelector } from 'react-redux';

const Timer = (props) => {
    const firstPlayerCardsData = useSelector((state) => state.playerCardDetail);
    const [seconds, setSeconds] = useState(45);
    const [show, setShow] = useState(false);
    const [showCountDown, setShowCountDown] = useState(false);
    const [showdata, setShowdata] = useState("");
 

    const formatTime = ({minutes, seconds}) =>{
        return (<><p className='countDown'><span className='coutDownMin'>{minutes}</span>:<span className='coutDownMin'>{seconds}</span></p></>)
    }

    useEffect(() => {
        const timer = setInterval(() => {
            setSeconds((prevSeconds) => {
                if (prevSeconds > 0) {
                    return prevSeconds - 1;
                }
                else {
                    clearInterval(timer);
                    setShow(true)
                    return 0;
                }

            });
        }
            , 1000);
        return () => {

            const timer = setInterval(() => {
                setSeconds((prevSeconds) => {
                    if (prevSeconds > 0) {
                        return prevSeconds - 1;
                    }
                    else {
                        clearInterval(timer);
                        setShow(true)
                        return 0;
                    }

                });
            }
                , 1000);

           
        }
    }, []);

    useEffect(() => {
        props.getTimer(seconds)
    }, [seconds])

    const handleClose = () => {
        setShow(false)
        setShowCountDown(true)
    };

const userId = localStorage.getItem("userId")
    const gameResultFunc = () => {

        const countDown = setInterval(() => {
            setSeconds(() => {
                setShowCountDown(true)
                console.log("gameResultFunccalled");
                setShow(false)
                
                if (firstPlayerCardsData?.list?.data?.turnPlayerId == userId) {
                    setShowdata("loose")
                  }
                  else {
                    setShowdata("win")
                  }
            });
        }
            , 5000*60);
    }

    return (
        <>
            {!show ?
                <div className={showCountDown ? "countDownClock" : "timer"} role="timer">
                    {!showCountDown ?
                        <div className="box">
                            <CircularProgressbar className={seconds > 10 ? 'start' : 'end'}
                                strokeWidth={8} value={seconds * 2.22} text={`${seconds}s`}
                            />
                        </div>
                        :
                        <div className='countDown'>
                            <Countdown date={Date.now() + 5000*60} renderer={({minutes, seconds})=> formatTime({minutes, seconds})} isStopped={true ? gameResultFunc() : ''} />
                        </div>
                    }

                </div>
                :
                <Modal show={show}
                    onHide={handleClose}
                    className='sessionTimer'
                >
                    <Modal.Body>
                        <div id="countdown">
                            <div id='tiles'></div>

                            <div className='text-white'>
                                <p className='mb-0'>Time left</p>

                                {/* <Countdown date={Date.now() + 5000*60} isStopped={true ? gameResultFunc() : ''} /> */}
                                <Countdown date={Date.now() + 5000*60} renderer={({minutes, seconds})=> formatTime({minutes, seconds})} isStopped={true ? gameResultFunc() : ''} />
                                {/* <Countdown date={Date.now() + 5000*60} onStop/> */}
                                {/* <Countdown date={Date.now() + 5000} onStop={(true) ? gameResultFunc() : ''}/> */}
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer className='border-0'>
                        <Button className='continueBtn' onClick={handleClose}>
                            Continue
                        </Button>
                    </Modal.Footer>

                </Modal>
            }
            <GinGameWinPage setShowdata={setShowdata} showdata={showdata} />
        </>
    );
};

export default Timer;

